export const skillStagger = {
    initial: {
        opacity: 0
    },
    animate: {
        opacity: 1,
        transition:{
            staggerChildren: .25,
            when: 'beforeChildren',
            duration: .5,
        }
    },
    exit: {
        opacity: 0
    }
}

export const skillsVariant = {
    initial:{
        opacity: 0,
    },
    animate:{
        opacity: 1,
        transition:{
            duration: 1.25,
            ease: "easeOut",
            staggerChildren: .25,
            when: 'beforeChildren',
        },
        width: ["0%", "0%", "1%", "100%"],
        height: ["0%", "1%", "40%", "40%"],
        borderRadius: [
            "50%", "50%", "50%", "16px"
        ],
        boxShadow: [
            "0 0 10px #00fff9",
            "0 0 15px #00fff9",
            "0 0 20px #00fff9",
            "0 0 25px #00fff9",
            "0 0 30px #00fff9",
            "0 0 30px #00fff9",
            "0 0 25px #00fff9",
            "0 0 20px #00fff9",
        ],
    },
    exit:{
        width: ["100%", "1%", "0%", "0%"],
        height: ["40%", "40%", "1%", "0%"],
        borderRadius: [
            "16px", "16px", "16px", "16px"
        ],
        opacity: [1, 1, 1, 0],
    }
}

export const aboutSlide = {
    initial: (custom) =>{
        return{
            x: custom,
            opacity: 0
        }
    },
    animate: {
        x: 0,
        opacity: 1,
        transition: {
            duration: 1.25,
            type: "spring"
        }
    },
    exit:(custom) =>{
        return{
            x: custom,
            opacity: 0,
            transition:{
                duration: .5
            }
        }
    }
}

export const fade = {
    initial:{
        opacity: 0,
    },
    animate:{
        opacity: 1,
        transition:{
            duration: 1.5,
            ease: "easeOut"
        }
    },
    exit:{
        opacity: 0
    }
}